<template>
  <div class="carousel">
    <div class="title">
      <h2 v-if="isLandscape && title">{{ title }}</h2>
    </div>
    <div class="selector">
      <font-awesome-icon icon="chevron-left" v-if="currentStyle == 'arrow' || currentStyle == 'full'" class="next" @click="changeSlide(-1)" />
      <div>
        <ul class="items">
          <li class="carousel-item" v-for="item in items" :key="item.value" :carousel-key="item.value" @click="updateItem(item)">
            {{ item.name.length > 10 ? item.name.slice(0, 7) + "…" : item.name }}
          </li>
          <li v-if="items.length === 0">No items available</li>
        </ul>
        <ul v-if="currentStyle == 'marker' || currentStyle == 'full'" class="markers">
          <li v-for="(idx, index) in slides" :key="idx" @click="scrollToItem(idx)">
            <input type="radio" name="carousel-markers" :value="index" :checked="currentIndex === index" />
          </li>
        </ul>
      </div>
      <font-awesome-icon icon="chevron-right" v-if="currentStyle == 'arrow' || currentStyle == 'full'" class="next" @click="changeSlide(1)" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    items: {
      // items should  have value, name and optionally selected
      // value is the value that will be sent back to the parent
      // name is the name that will be displayed in the carousel
      // selected is the value that will be selected by default
      type: Array,
      required: true,
    },
    title: {
      // title of the carousel, will only show in landscape mode
      type: String,
      required: false,
    },
    style: {
      // choose the style of the carousel
      // full = bottom scroll markers and arrows
      // arrow = just left and right arrows
      // marker = just scroll marks
      // simple = only the items with no marks
      type: String,
      default: "full",
      required: false,
    },
  },
  emits: ["selectItem"],
  data() {
    return {
      currentIndex: 0, // Track the current index for selected
      // find out if there is a selected from the database
      selected: this.getSelectedFromItems(),
      isLandscape: null,
      currentStyle: this.getStyle(),
      // use this object instead of making each time
    };
  },
  computed: {
    slides() {
      // calculate the number of slides based on items length
      // if all is true then we need to add 1 to the count
      //let count = this.items.length;
      //if (this.all) count++;
      return this.items.length;
    },
  },
  methods: {
    // for the left and right buttons
    changeSlide(direction) {
      // so that we dont go past -1 or past limit
      if (this.currentIndex + direction >= -1 && this.currentIndex + direction != this.slides) {
        this.currentIndex += direction;
      } else {
        // dont change the slide if it out of bounds
        return;
      }
      // get the list from the html
      const list = this.$el.querySelector("ul");
      // scroll to the next item
      list.scrollBy({ left: direction * 100, behavior: "smooth" });

      // get the item from the list

      let item = this.getItem(this.currentIndex);
      // select the item that appears when arrow is clicked
      this.updateItem(item);
    },

    // get the item within the list from the index given (-1 is all)
    // send +1 if there is no null, so that all isnt called when index is 0
    getItem(index) {
      return this.items[index];
    },

    // get the style for the chevrons, dots and title
    getStyle() {
      // check if in landscape
      let orientation = window.matchMedia("(orientation: landscape)");
      this.isLandscape = orientation.matches;
      let newStyle = "simple";
      if (this.isLandscape) {
        // the current style will be the one that is
        newStyle = this.style;
      } else {
        newStyle = "marker";
      }
      this.currentStyle = newStyle;
      return newStyle;
    },

    updateItem(item) {
      this.items.forEach((i) => {
        if (i.value === item.value) {
          i.selected = true;
        } else {
          i.selected = false;
        }
      });
      // make sure the current index is up to date
      
      this.currentIndex = this.getIndexFromItem(item);

      const list = this.$el.querySelector(".items");
      Array.from(list.children).forEach((li) => {
        li.classList.remove("selected");
      });
      const selectedLi = list.children[this.currentIndex];
      if (selectedLi) {
        selectedLi.classList.add("selected");
      }
      if (item.value) {
        this.$emit("selectItem", item.value);
        //this.selected = item.value;
      }
      //this.observeSwipe();
    },

    // find the index from the item
    getIndexFromItem(item) {
      const index = this.items.findIndex((i) => i.value === (item && item.value));
      return index;
    },

    scrollToItem(index) {
      // how do we keep radio button checked?
      // doesnt match up with using left and right buttons
      const list = this.$el.querySelector(".items");

      if (this.currentIndex != -1) {
        // if not all
        let currentItem = null;
        let item = list.children[index - 1]; //only -1 if all
        currentItem = this.getItem(index);
        if (currentItem) {
          item.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
          this.updateItem(currentItem);
        }
      } else {
        // if all
        const item = list.querySelector("li:first-child");
        if (item) {
          item.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
          this.updateItem(item);
        }
      }
    },
    getSelectedFromItems() {
      //Check if there is a selected item in the items array
      return this.items.find((item) => item.selected);
    },
    observeSwipe() {
      // Use Intersection Observer to add 'selected' class when item is in view
      const list = this.$el.querySelector(".selector .items");
      if (list && "IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                //this.updateItem(entry.target.attributes["carousel-key"]);
                if (this.selected.value) {
                  this.updateItem(entry.target.attributes["carousel-key"]);
                }
              }
            });
          },
          {
            root: list,
            threshold: 0.6, // Adjust as needed for how much should be visible
          }
        );
        Array.from(list.children).forEach((li) => {
          observer.observe(li);
        });
        //observer.observe(this.$el.querySelector(".selector .items .carousel-item"))
      }
    },
  },
  mounted() {
    // Optionally, you can scroll to the selected item on mount
    if (this.selected) {
      // get the index of the selected item
      const index = this.getIndexFromItem(this.selected);
      // index will be -1 if it is not in the items such as if all or null is selected
      const list = this.$el.querySelector(".items");
      if (index !== -1) {
        // update the current index
        this.currentIndex = index;

        const item = list.children[index];
        // get the list from the document and scroll to the item
        if (item) {
          item.scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" });
          // add the selected class to item to update the style
          item.classList.add("selected");
        }
      } else {
        this.currentIndex = 0; // Default to the first item if not found
        const item = list.querySelector("li:first-child");

        if (item) {
          item.scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" });
          item.classList.add("selected");
        }
      }
    }
    // this.isLandscape = window.matchMedia("(orientation: landscape)").matches;
    let orientation = window.matchMedia("(orientation: landscape)");
    this.isLandscape = orientation.matches;
    orientation.addEventListener("change", (event) => {
      this.isLandscape = event.matches;
      this.currentStyle = this.getStyle();
    });
    this.observeSwipe();
  },

  watch: {
    /***selected() {
      this.observeSwipe();
    },***/
  },
};
</script>

<style scoped lang="scss">
.carousel {
  border-radius: 0.5rem;
  padding: 0;
  margin: 0.25rem;
  // box-shadow: var(--box-shadow); //for testing size
  min-width: calc(100vw / 8);
  height: calc(100vh / 8);
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    h2 {
      margin: 0.5rem;
      padding: 0;
      font-size: 1rem;
      color: var(--text-colour);
    }
  }
  .selector {
    max-height: calc(100vh / 8);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: baseline;
    .next {
      cursor: pointer;
      color: var(--action-colour);
      font-size: 1rem;
      align-items: center;
      margin-top: 1rem;
    }
    .items {
      width: calc(100vw / 15);
      height: calc(100vh / 25);
      margin: 0.25rem;
      display: flex;
      gap: 1rem;
      overflow-x: scroll;
      scroll-snap-type: x mandatory;
      mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
      -ms-overflow-style: none; // for IE and Edge
      scrollbar-width: none; //for firefox
      li {
        align-content: center;
        min-width: calc(100vw / 15);
        list-style: none;
        background-color: var(--primary-colour);
        border-radius: 0.5rem;
        padding: 0.5rem;
        text-align: center;
        scroll-snap-align: center;
        text-transform: capitalize;
        margin-right: 1rem;
        &:hover {
          transform: scale(1.05);
          background-color: var(--hover-colour);
        }
      }
      .selected {
        background-color: var(--action-colour);
        color: var(--text-colour);
      }
    }
    .items::-webkit-scrollbar {
      // for chrome, safari and opera
      display: none;
    }
    .markers {
      display: flex;
      justify-content: center;
      margin: 0;
      padding-inline-start: 0px;
      li {
        list-style: none;
        input {
          appearance: none;
          margin-right: 0.5rem;
          border-radius: 50%;
          transition: all 500ms ease-in-out;
          height: 0.5rem;
          width: 0.5rem;
          white-space: nowrap;
          border: 2px solid var(--action-colour);
          &:checked {
            background-color: var(--action-colour);
            border: 5px solid var(--action-colour);
          }
        }
      }
    }
  }
}
@media only screen and (orientation: portrait) {
  .carousel {
    min-height: 5rem;
    // width: 8rem;
    padding-top: 1rem;
    .selector {
      .next {
        height: 2rem;
        p {
          font-size: 2.5rem;
        }
      }
      .items {
        width: 5rem;
        height: 3rem;
        margin: 1;
        // padding: 0;
        li {
          min-width: 4rem;
          height: 1.5rem;

          &:hover {
            transform: scale(1.05);
            background-color: var(--action-colour) !important;
          }
        }
      }
    }
  }
}
</style>
